<template>
  <div class="submit-success-contianer" :class="$platformClass">
    <Icon type="storesuccess" class="success-icon"></Icon>
    <p class="success-tips" :class="$platformClass" v-html="tips"></p>
  </div>
</template>

<script>
export default {
  props: ['tips'],
};
</script>
